import HeaderComponent from './Header.component'

export { default as Header } from './Header.component'
export { default as HamburguerMenu } from './HamburguerMenu.component'
export { default as Editorials } from './EditorialsComponent'
export { default as UserMenu } from './UserMenu.component'
export { default as CTAJotaPro } from './CTAPRO.component'
export { default as HeaderBase } from './Header.base.component'
export default HeaderComponent
